import type {FC} from 'react';
import {Box} from "@mui/material";
import React from 'react';
import LoadingIndicator from "./LoadingIndicator";


const SplashScreen: FC = () => (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        color: 'text.primary',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        p: 3,
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 2000,
      }}
    >
      <LoadingIndicator label="Loading your account"/>
    </Box>
);

export default SplashScreen;
